import React, {useEffect} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
// reactstrap components
import {Col, Container, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../translations/common_translations";
import AuthNavbar from "../components/Navbars/AuthNavbar";
import routes from "../routes";
import AuthFooter from "../components/Footers/AuthFooter";
import {useObservable} from "../components/utils/observable/observableHook";
import {bTypeService, localeService} from "../components/utils/observable/services";

// core components

let commonStrings = new LocalizedStrings(common_strings);

const Auth = () => {
    const locale = useObservable(localeService.locale);
    const business_type = useObservable(bTypeService.bType);

    useEffect(() => {
        window.addEventListener('language_changed', handleLanguageChange);
        document.body.classList.add("bg-yellow-open");

    }, []);

    useEffect(() => {

        return () => {
            document.body.classList.remove("bg-yellow-open");
            window.removeEventListener('language_changed', handleLanguageChange);
        }
    }, []);

    const handleLanguageChange = (event) => {
        localeService.setLocale(event.detail.l)
        localize()
    };

    function localize() {
        commonStrings.setLanguage(locale);
    }

    localize();

    const getRoutes = routes => {
        return routes.map((prop, key) => {
            if (prop.layout === "/auth") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        component={prop.component}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    function getTypeImage() {
        switch (business_type) {
            case "yoga":
                return require("assets/img/theme/yoga-login.jpg");
            case "gym":
                return require("assets/img/brand/man-working-out.png");
            case "dance":
                return require("assets/img/theme/dance-login.jpg");
            case "ma":
                return require("assets/img/theme/ma-login.jpg");
            default:
                return require("assets/img/theme/yoga-login.jpg");
        }
    }

    function getPositionType() {
        switch (business_type) {
            case "yoga":
                return "center"
            case "gym":
                return "top"
            case "dance":
                return "center"
            case "ma":
                return "center"
            default:
                return "center"
        }
    }

    return (
        <>
            <div className="main-content" style={{backgroundColor: "#323238"}}>
                <AuthNavbar/>
                <div className="header py-7 py-lg-8"
                     style={{
                         height: "600px",
                         backgroundImage:
                             "url(" + getTypeImage() + ")",
                             // "url(" + require("assets/img/theme/gym-login-2.jpg") + ")",
                         backgroundSize: "cover",
                         backgroundPosition: getPositionType()
                     }}
                >
                    <span className="mask bg-gradient-dark opacity-8"/>
                    <Container>
                        <div className="header-body text-center mb-7">
                            <Row className="justify-content-center">
                                <Col lg="5" md="6">
                                    <h1 className="text-white">{commonStrings.welcome_to_open}</h1>
                                    <p className="text-lead text-secondary mt-4 text-unselectable">
                                        {commonStrings.open_expl_login}
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100" >
                        <svg

                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                fill="#323238"
                                // className="fill-default"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </div>
                {/* Page content */}
                <Container className="mt--8 pb-5">
                    <Row className="justify-content-center">
                        <Switch>
                            {getRoutes(routes)}
                            <Redirect from="*" to="/auth/login"/>
                        </Switch>
                    </Row>
                </Container>
            </div>
            <AuthFooter/>
        </>
    );
};

export default Auth;
